module.exports = __webpack_public_path__ + "static/media/bg.80cb567a.svg";